/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
//import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import VueAnalytics from 'vue-analytics';
Vue.use(Vuesax)


// axios
import axios from './axios.js'
Vue.prototype.$http = axios
import VueGtm from '@gtm-support/vue2-gtm';
// API Calls
//import './http/requests'

// mock
//import './fake-db/index.js'

// Theme Configurations
//import '../themeConfig.js'


// Firebase
import '@/firebase/firebaseConfig'
import firebase from 'firebase';
import jwt_decode from "jwt-decode";
import ls from "@/common/localStorage"


// Auth0 Plugin
import AuthPlugin from './plugins/auth'
Vue.use(AuthPlugin)


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'

// CUSTOM CSS
import '@/assets/css/custom.css'

// CUSTOM CSS
import '@/assets/css/update.css'

// CHECKIN CSS
import '@/assets/css/checkin.css'
// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// ================
// Vue-stash aka simple vuex alternative
// ----------------
//import VueStash from 'vue-stash'
//Vue.use(VueStash)


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
/*import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)*/


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
//Vue.use(VeeValidate)
Vue.use(VeeValidate, {
  events: 'blur'
});


// Google Maps
/*import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_KEY',
        libraries: 'places' // This is required if you use the Auto complete plug-in
    }
})*/

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
//import 'prismjs'
//import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')




// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

// import './assets/css/quasar.styl'
//import 'quasar/dist/quasar.ie.polyfills'
//import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar'


Vue.use(Quasar, {
  config: {}
})

var hostUrl = location.host.toLowerCase();
if (hostUrl.includes("localhost") && hostUrl.includes("stage")) {

} else if (hostUrl.includes("uat")) {
  Vue.use(VueGtm, {
    id: 'GTM-KSQ44VC',
    defer: false,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
  });
} else {
  Vue.use(VueGtm, {
    id: 'GTM-MTH7T3K',
    defer: false,
    enabled: true,
    debug: true,
    loadScript: true,
    vueRouter: router,
    trackOnNextTick: false
  });
};

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    router.checkLoginTime();
    if (Math.round(new Date() / 1000) > ls.getSessionValueByKey('idTExp') && ls.getSessionValueByKey('il')) {
      firebase.auth().currentUser.getIdToken(true).then(idToken => {
        var decodedToken = jwt_decode(idToken);
        ls.setSessionUserInfo({ Session_AccessToken: idToken, idTExp: decodedToken.exp });
        config.headers['Authorization'] = 'Bearer ' + idToken;
        return config;
      })
    }
    return config;
  },
  error => {
    Promise.reject(error)
  });

//Add a response interceptor

const resInterceptor = axios.interceptors.response.use((response) => {
  let originalRequest = response.config;
  if (response.data.status === -10 && !originalRequest._retry) {
    originalRequest._retry = true;
    firebase.auth().currentUser.getIdToken(true).then(idToken => {
      var decodedToken = jwt_decode(idToken);
      ls.setSessionUserInfo({ Session_AccessToken: idToken, idTExp: decodedToken.exp });
      originalRequest.headers['Authorization'] = 'Bearer ' + idToken;
      return axios(originalRequest);
    }).catch(err => {
      firebase.auth().signOut().then(() => {
        ls.sessionLogOut();
        location.href = "/pages/login";
        //this.$router.push('/pages/login');
      })
    })
  }
  if (response.data.status === -11 || response.data.status === -12) {
    firebase.auth().signOut().then(() => {
      ls.sessionLogOut();
      location.href = "/pages/login";
      // this.$router.push('/pages/login');
    })
  }
  return response
}, function (error) {
  return Promise.reject(error);
});

Vue.config.productionTip = false
export const bus = new Vue();
new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')